import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicStorageTech = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Electronic, Magnetic, and Optical Technologies"
      videos={[
        "https://www.youtube.com/embed/tRNIHqzNEvU"
      ]}
      takeaways={[
        { text: "Just have an overview of every type of storage technology." }
      ]}
      questions={[]} // No questions provided
      exampleVideos={[]} // No example videos provided
    />
);
}

export default ModuleSubtopicStorageTech;
